import { Pipe, PipeTransform } from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
    name: 'listSearchPipe',
})
export class ListSearchPipe implements PipeTransform {
    datePipe = new DatePipe('en-US');

    transform(items: any[], searchParam: string, searchValue: string ): any {
        return !items ? [] : !searchParam ? items : items.filter((item) => {
            if ((isNaN(item[searchParam]))) {
                return String(item[searchParam]).toLowerCase().includes(searchValue.trim().toLowerCase());
            }
        });
    }
}
